import {BaseEntityForm} from "@core/model";
import * as yup from "yup";

const taskForm: BaseEntityForm = {
  columns: [
    {field: "id", fieldType: "id", hideForm: true},
    {field: "name", fieldType: "string", headerName: "entity.task.name"},
    {
      field: "description",
      fieldType: "string",
      headerName: "entity.task.description",
    },
    {
      field: "assigneeId",
      fieldType: "user",
      headerName: "entity.task.assignee",
    },
    {
      field: "assetId",
      fieldType: "asset",
      headerName: "entity.task.asset",
    },
    {field: "start", fieldType: "datetime", headerName: "entity.task.start"},
    {field: "end", fieldType: "datetime", headerName: "entity.task.end"},
    {
      field: "recurring",
      fieldType: "boolean",
      headerName: "entity.task.recurring",
    },
    {
      field: "tags",
      fieldType: "tags",
      headerName: "entity.task.tags",
    },
  ],
  validation: yup.object({
    name: yup.string().required("error.validation.required"),
    description: yup.string().required("error.validation.required"),
    start: yup.number().required("error.validation.required"),
    end: yup.number().required("error.validation.required"),
    tags: yup.array().of(yup.string()).nullable(),
  }),
};

const taskRecurringForm: BaseEntityForm = {
  columns: [
    {field: "id", fieldType: "id", hideForm: true},
    {field: "name", fieldType: "string", headerName: "entity.task.name"},
    {
      field: "description",
      fieldType: "string",
      headerName: "entity.task.description",
    },
    {
      field: "assigneeId",
      fieldType: "user",
      headerName: "entity.task.assignee",
    },
    {
      field: "assetId",
      fieldType: "asset",
      headerName: "entity.task.asset",
    },
    {
      field: "tags",
      fieldType: "tags",
      headerName: "entity.ticket.tags",
    },
    {field: "start", fieldType: "datetime", headerName: "entity.task.start"},
    {field: "end", fieldType: "datetime", headerName: "entity.task.end"},
    {
      field: "recurring",
      fieldType: "boolean",
      headerName: "entity.task.recurring",
    },
    {
      field: "recurrenceEnd",
      fieldType: "datetime",
      headerName: "entity.task.recurrenceEnd",
    },
    {
      field: "recurrenceRule",
      fieldType: "select",
      headerName: "entity.task.recurrenceRule",
    },
  ],
  validation: yup.object({
    name: yup.string().required("error.validation.required"),
    description: yup.string().required("error.validation.required"),
    recurrenceRule: yup.string().required("error.validation.required"),
    start: yup.number().required("error.validation.required"),
    tags: yup.array().of(yup.string()).nullable(),
  }),
};

export {taskForm, taskRecurringForm};
